/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbActionMenuItem } from "abreact/incubator/ui/component/actionBar/AbActionMenuItem";
export class AbActionBarItem extends AbActionMenuItem {
  constructor(icon, callback, enabled = true, tooltip, shortcut = null, dataTestId) {
    super(icon, tooltip === undefined ? null : tooltip, callback, enabled, shortcut, dataTestId);
  }
}
//# sourceMappingURL=AbActionBarItem.js.map
